import axios, { AxiosResponse } from 'axios'

async function getFreshData(dataKey: string, freshAccount: FreshAccount, categoryId: any): Promise<FreshRes[]> {
  let getData
  let pageNumber = 1

  switch (dataKey) {
    default:
      getData = getFreshDepartments
      break
    case 'departments':
      getData = getFreshDepartments
      break
    case 'agents':
      getData = getFreshAgents
      break
    case 'categories':
      getData = getFreshCategories
      break
    case 'groups':
      getData = getFreshGroups
      break
    case 'catalog':
      getData = getFreshCatalog
      break
  }

  const res: FreshRes[] = await getData(freshAccount, pageNumber, categoryId)
  while (res.length % 30 === 0 && pageNumber !== 0) {
    if(process.env.NODE_ENV !== 'production') console.log('inside while')
    pageNumber++
    const moreResults: FreshRes[] = await getData(freshAccount, pageNumber, categoryId)
    if (!moreResults || moreResults.length === 0) {
      if(process.env.NODE_ENV !== 'production') console.log('inside while - no more items')
      pageNumber = 0
    } else {
      res.push(...moreResults)
      if(process.env.NODE_ENV !== 'production') console.log('inside while - ', res.length, moreResults.length)
    }
  }
  if(process.env.NODE_ENV !== 'production') console.log(`no while - ${dataKey} res length `, res.length)
  return res
}

async function getFreshDepartments(freshAccount: FreshAccount, page: number = 1): Promise<FreshRes[]> {
  const { freshApiKey, freshDomain } = freshAccount
  try {
    const res: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/departments?page=${page}`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })
    const departments: FreshRes[] = res.data.departments.map((department: any) => {
      return { name: department.name, id: department.id }
    })

    return departments
  } catch (err) {
    console.log('file: freshService.ts -> line 66 -> getFreshDepartments -> err', err)
    throw err
  }
}

async function getFreshAgents(freshAccount: FreshAccount, page: number = 1): Promise<FreshRes[]> {
  const { freshApiKey, freshDomain } = freshAccount

  try {
    const res: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/agents?page=${page}`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })
    const agents: FreshRes[] = res.data.agents.map((agent: any) => {
      const name: string = `${agent.first_name} ${agent.last_name}`.trim()
      return { name, id: agent.id }
    })
    if(process.env.NODE_ENV !== 'production') console.log('agents', agents)
    return agents
  } catch (err) {
    console.log('file: freshService.ts -> line 100 -> getFreshAgents -> err', err)
    throw err
  }
}

async function getAgentsGroups(freshAccount: FreshAccount, groupId: string | number): Promise<number[]> {
  const { freshApiKey, freshDomain } = freshAccount
  try {
    const res: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/groups/${groupId}`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })
    return res.data.group.members
  } catch (err) {
    console.log('file: freshService.ts -> line 109 -> getAgentsGroups -> err', err)
    throw err
  }

  // if(!res.data.group.members.length) return null
  // else {
  //   console.log('im here?')
  //   const agents = []
  //   for(let i = 0; i < res.data.group.members.length; i++) {
  //     const agentsRes: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/agents/${res.data.group.members[i]}`, {
  //       headers: {
  //         Authorization: `Basic ${btoa(freshApiKey!)}`,
  //         'Content-Type': 'application/json',
  //       }
  //     })
  //     console.log('agentsRes.data',agentsRes.data);
  //     agents.push(agentsRes.data.agent);
  //   }
  //   console.log("file: freshService.ts -> line 113 -> getAgentsGroups -> agents", agents)
  //   const agentsByGroup: any[] = agents.map((agent: any) => {
  //     const name: string = `${agent.first_name} ${agent.last_name}`.trim()
  //     return { name, id: agent.id }
  //   })
  //   console.log('agentsByGroup', agentsByGroup)
  //   return agentsByGroup
  // }
}

async function getFreshCategories(freshAccount: FreshAccount, page: number = 1): Promise<FreshRes[]> {
  const { freshApiKey, freshDomain } = freshAccount

  try {
    const res: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/service_catalog/categories?page=${page}`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })
    const categories: FreshRes[] = res.data.service_categories.map((category: any) => {
      return { name: category.name, id: category.id }
    })
    return categories
  } catch (err) {
    console.log('file: freshService.ts -> line 153 -> getFreshCategories -> err', err)
    throw err
  }
}

async function getFreshGroups(freshAccount: FreshAccount, page: number = 1): Promise<FreshRes[]> {
  const { freshApiKey, freshDomain } = freshAccount
  try {
    const res: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/groups?page=${page}`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })
    const groups: FreshRes[] = res.data.groups.map((group: any) => {
      return { name: group.name, id: group.id }
    })
    return groups
  } catch (err) {
    console.log('file: freshService.ts -> line 173 -> getFreshGroups -> err', err)
    throw err
  }
}

export async function getFreshFields(freshAccount: FreshAccount): Promise<TicketFieldsData[]> {
  const { freshApiKey, freshDomain } = freshAccount
  try {
    const res: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/ticket_form_fields`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })
    const ticketFields: TicketFieldsData[] = res.data.ticket_fields
      .filter((ticketField: TicketFieldsData) => ticketField.name !== 'requester' && ticketField.name !== 'subject' && ticketField.name !== 'ticket_type' && ticketField.name !== 'workspace_id')
      .map((ticketField: any) => {
        return { label: ticketField.label, isRequired: ticketField.required_for_agents, placeholder: ticketField.description, options: ticketField.choices, name: ticketField.name, id: ticketField.id, fieldType: ticketField.field_type }
      })
    return ticketFields
  } catch (err) {
    console.log('file: freshService.ts -> line 164 -> getFreshFields -> err', err)
    throw err
  }
}

async function getFreshCatalog(freshAccount: FreshAccount, page: number, categoryId: number): Promise<FreshRes[]> {
  const { freshApiKey, freshDomain } = freshAccount
  try {
    const res: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/service_catalog/items?category_id=${categoryId}?page=${page}`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })

    const freshCatalog: FreshRes[] = res.data.service_items
      .filter((item: any) => item.visibility === 2)
      .map((item: any) => {
        const { name, display_id } = item
        return { name, id: display_id }
      })

    return freshCatalog
  } catch (err) {
    console.log('file: freshService.ts -> line 220 -> getFreshCatalog -> err', err)
    throw err
  }
}

/**
return custom field / child items by data string
 */
async function getFreshItemData(freshAccount: FreshAccount, catalogId: number | string, data: 'customFields' | 'childItems') {
  const { freshApiKey, freshDomain } = freshAccount
  try {
    const res: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/service_catalog/items/${catalogId}`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })

    if (data === 'customFields') return res.data.service_item.custom_fields
    else if (data === 'childItems') {
      const childItems = []
      if (res.data.service_item.child_items.length) {
        for (let i = 0; i < res.data.service_item.child_items.length; i++) {
          const childItem = res.data.service_item.child_items[i]

          const childItemRes: AxiosResponse = await axios.get(`https://${freshDomain}.freshservice.com/api/v2/service_catalog/items/search?search_term=${childItem.name}`, {
            headers: {
              Authorization: `Basic ${btoa(freshApiKey!)}`,
              'Content-Type': 'application/json',
            },
          })
          const customFields = childItemRes.data.service_items[0].custom_fields
          const { display_id } = childItemRes.data.service_items[0]
          if(process.env.NODE_ENV !== 'production') console.log('file: freshService.ts -> line 176 -> getFreshItemData -> display_id', display_id)
          childItems.push({ ...childItem, customFields, display_id, isChecked: childItem.mandatory === 1 ? true : false })
        }
      }
      return childItems
    }
  } catch (err) {
    console.log('file: freshService.ts -> line 232 -> getFreshItemData -> err', err)
  }
}

async function createSource(freshAccount: FreshAccount, sourceName: string): Promise<DropDownOption> {
  const { freshApiKey, freshDomain } = freshAccount
  const data = JSON.stringify({ name: sourceName })
  if(process.env.NODE_ENV !== 'production') console.log('file: freshService.ts -> line 277 -> createSource -> data', data)
  try {
    const res: AxiosResponse = await axios.post(`https://${freshDomain}.freshservice.com/api/v2/ticket_fields/sources`, `${data}`, {
      headers: {
        Authorization: `Basic ${btoa(freshApiKey!)}`,
        'Content-Type': 'application/json',
      },
    })
    return {label: sourceName, value: res.data.source.choice_id}
  } catch (err) {
    console.log('file: freshService.ts -> line 173 -> getFreshGroups -> err', err)
    throw err
  }
}

// async function getFreshCatalog({ apiKey, domain }: FreshAccount, page: number, categoryId: string | number): Promise<{ name: string; id: number }[]> {
//   // console.log(`getItemsCatalog -> apiKey`, apiKey);
//   // console.log(`getItemsCatalog -> domain`, domain);
//   if (apiKey && domain) {
//     const res = await axios.get(`https://${domain}.freshservice.com/api/v2/service_catalog/items?category_id=${categoryId}?page=${page}`, {
//       headers: {
//         Authorization: `Basic ${btoa(apiKey)}`,
//         'Content-Type': 'application/json',
//       },
//     })
//     // console.log(`getItemsCatalog -> res`, res);
//     if (res.status === 200) {
//       const items: [] = res.data.service_items.filter((item: { visibility: number; name: string; display_id: number }) => item.visibility === 2)
//       const serviceItems: { name: string; id: number }[] = items.map((item) => {
//         const { name, display_id } = item
//         return { name, id: display_id }
//       })
//       return serviceItems
//     } else return []
//   } else return []
// }

export const freshService = {
  getFreshData,
  getFreshCatalog,
  getFreshItemData,
  getFreshFields,
  getAgentsGroups,
  createSource,
}
